"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomRepetitionType = void 0;
// eslint-disable-next-line no-shadow
var CustomRepetitionType;
(function (CustomRepetitionType) {
    CustomRepetitionType["WEEKLY"] = "weekly";
    CustomRepetitionType["MONTHLY"] = "monthly";
    CustomRepetitionType["MONTHLY_BY_DATE"] = "monthly-by-date";
    CustomRepetitionType["YEARLY"] = "yearly";
    CustomRepetitionType["YEARLY_BY_DATE"] = "yearly-by-date";
})(CustomRepetitionType = exports.CustomRepetitionType || (exports.CustomRepetitionType = {}));
exports.default = CustomRepetitionType;
